// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const Filter = (): React.Element<*> => (
  <path d="M16.952 2.79c-0.081-0.172-0.253-0.289-0.453-0.29h-13c-0 0-0 0-0 0-0.276 0-0.5 0.224-0.5 0.5 0 0.124 0.045 0.237 0.12 0.324l-0.001-0.001 5.381 6.345v7.332c0 0.276 0.224 0.5 0.5 0.5 0.113 0 0.217-0.038 0.301-0.101l-0.001 0.001 2-1.5c0.122-0.092 0.2-0.237 0.2-0.4v-5.818l5.382-6.359c0.073-0.086 0.118-0.199 0.118-0.323 0-0.076-0.017-0.149-0.048-0.214l0.001 0.003zM10.498 15.25l-1 0.75v-6h1zM10.768 8.996l-1.537-0.010-4.653-5.486h10.842z"></path>
);
